<template>
  <div>
    <NuxtLayout>
      <div class="page page-error">
        <div
          v-html="
            error.statusCode === 500
              ? $t('errors.500.text')
              : $t('errors.404.text')
          "
        />
        <NuxtLink :to="localePath({ name: 'index' })" external>Home</NuxtLink>
      </div>
    </NuxtLayout>
  </div>
</template>

<script setup>
const localePath = useLocalePath()

const props = defineProps({
  error: Object,
})

// Inizializzo lo scroller e lo inietto nella app ion modo da averlo sempre accessibile
const { lenis } = useLenis({
  anchors: true,
})
provide('lenis', lenis)
</script>
